import { CryptoPreviewBottomSheet as UICryptoPreviewBottomSheet, type CryptoPreviewBottomSheetProps } from '@jagad/ui';
import { useTranslation } from 'react-i18next';

type Props = Omit<
  CryptoPreviewBottomSheetProps,
  | 'fromLabel'
  | 'receiveLabel'
  | 'previewTitle'
  | 'minimumLimitLabel'
  | 'rateLabel'
  | 'rateValidForLabel'
  | 'totalAmountLabel'
  | 'getDepositAddressLabel'
>;

const CryptoPreviewBottomSheet = (props: Props) => {
  const { t } = useTranslation();
  return (
    <UICryptoPreviewBottomSheet
      {...props}
      fromLabel={t('topUpCrypto.preview.from')}
      receiveLabel={t('topUpCrypto.preview.receive')}
      previewTitle={t('topUpCrypto.preview.preview')}
      minimumLimitLabel={t('topUpCrypto.preview.minimumLimit')}
      rateLabel={t('topUpCrypto.preview.rate')}
      rateValidForLabel={t('topUpCrypto.preview.rateValidFor')}
      totalAmountLabel={t('topUpCrypto.preview.totalAmount')}
      getDepositAddressLabel={t('topUpCrypto.preview.getDepositAddress')}
    />
  );
};

export default CryptoPreviewBottomSheet;
